var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{staticStyle:{"fill":"#85847c"},attrs:{"d":"M16.67,6.67V3.33H13.33V0H0V13.33H3.33v3.34H6.67V20H20V6.67ZM3.33,12.33H1V1H12.33V3.33h-9Zm1,3.34V4.33H15.67V6.67h-9v9ZM19,19H7.67V7.67H19Z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }